import {Injectable} from '@angular/core';
import {Event, InlineCheckout, ModalCheckout} from '@bambora/checkout-sdk-web';
import AbstractIframeCheckout from '@bambora/checkout-sdk-web/dist/types/abstractIframeCheckout';

@Injectable()
export class BamboraCheckoutService {
  public creteInlineCheckout(snippedData: any,
                             onError: (error: any) => any,
                             containerToEmbed: HTMLElement): InlineCheckout {

    const checkout = new InlineCheckout(snippedData.token);
    (checkout as InlineCheckout)
      .mount(containerToEmbed)
      .catch(err => onError(err));

    return checkout;
  }

  public createCheckout(snippedData: any,
                        onError: (error: any) => any,
                        event?: MouseEvent): ModalCheckout {
    const checkout = new ModalCheckout(snippedData.token);
    (checkout as ModalCheckout)
      .show(event)
      .catch(err => onError(err));
    return checkout;
  }

  public subscribeOnEvents(checkout: AbstractIframeCheckout<any>,
                           onSuccess: (payload: any) => any,
                           onCancel?: (payload: any) => any) {

    checkout.on(
      Event.Close,
      (payload) => onSuccess(payload)
    );

    checkout.on(
      Event.Cancel,
      (payload) => onCancel(payload));

    return checkout;
  }
}
